"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import type { ReactNode } from "react";

/** Only the optional couples query depends on the current URL. */
export default function RelatedConditionLink({
  href,
  ...props
}: {
  href: string;
  className: string;
  children: ReactNode;
}) {
  const searchParams = useSearchParams();
  const destination =
    searchParams.get("couples") === "1" && !href.includes("?")
      ? `${href}?couples=1`
      : href;

  return <Link href={destination} scroll={false} {...props} />;
}
